import type { AuthSession } from '@vanialabs/core-auth';
import type { LoginResponseDTO } from './login';

export function toAuthSession(
  response: LoginResponseDTO
): AuthSession {
  const representative = response.representative;

  const name =
    representative.full_name?.trim() ||
    representative.mobile;

  return {
    accessToken: response.access_token,

    activeContextId: `representative:${representative.id}`,

    expiresAt: response.expires_at,

    user: {
      id: String(representative.id),
      mobile: representative.mobile,
      name,

      ...(representative.avatar_url
        ? {
            avatarUrl: representative.avatar_url,
          }
        : {}),
    },
  };
}
